import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import CustomLoader from "../../CustomComponents/loader/CustomLoader";
import HomeServices from "../../Services/HomeServices";
import "./Pages.css";
import { useNavigate } from "react-router-dom";

const AddService = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState([]);

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    setSelectedTypes((prev) =>
      checked ? [...prev, value] : prev.filter((type) => type !== value)
    );
  };

  const initValue = {
    serviceName: "",
    documentation: selectedTypes
  };

  const [formValue, setFormValue] = useState(initValue);

  // submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formValue.serviceName) return toast.error("Service Name should not be empty")

    try {
      const response = await HomeServices.addService(formValue)

      if (response.status) {
        console.log("EER37", response);
        // formValue(initValue)
        toast.success(response.message)
        navigate("/services")
      } else {
        toast.error(response.message)
      }
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    }

  };

  const fetchDocumentTypes = async () => {
    try {
      // Call your API function
      const response = await HomeServices.getAllDocumentTypes();
      console.log("WED62", response.data);
      if (response && response?.status) {
        setDocumentTypes(response.data)
      };

    } catch (error) {
      console.error("Error fetching warehouse data:", error);
    }
  };



  console.log("YTR21", formValue.documentation);

  useEffect(() => {
    fetchDocumentTypes()
  }, [])

  useEffect(() => {
    setFormValue({ ...formValue, documentation: selectedTypes })
  }, [selectedTypes])


  return (
    <>

      <div className="d-flex justify-content-end mt-5">
        <div className="form-header">
          <section className="piechartsBox_area">
            {/* <BackPageBtn backLink="/" /> */}

            <form>

              <div>
                <h1 style={{ color: "#ff9c00" }}>Add AddService</h1>
              </div>

              <div className="row mt-4">
                <div className="col">
                  <label htmlFor="formGroupExampleInput">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Service Name"
                    name="serviceName"
                    value={formValue?.serviceName}
                    onChange={(e) => { setFormValue({ ...formValue, serviceName: e.target.value }) }}
                  />
                </div>
              </div>

              {/* <div className="row mt-4">
                <div className="col">
                  <label htmlFor="formGroupExampleInput">Required Documents</label>
                  {documentTypes.map((type, key) => (
                    <div key={key}>
                      <label>
                        <input
                          type="checkbox"
                          value={type._id}
                          checked={selectedTypes.includes(type._id)}
                          onChange={handleCheckboxChange}
                          style={{ marginRight: "10px" }}
                        />
                        {type.document}
                      </label>
                    </div>
                  ))}
                </div>
              </div> */}

              <div className="row mt-4">
                  <div className="col">
                    <label htmlFor="formGroupExampleInput" className="form-label">
                      Required Documents
                    </label>
                    {documentTypes.map((type, key) => {
                      const isChecked = selectedTypes.includes(type._id);
                      return (
                        <div key={key}>
                          <label
                            className={`checkbox-label ${isChecked ? 'checked' : ''}`}
                          >
                            <input
                              type="checkbox"
                              value={type._id}
                              checked={isChecked}
                              onChange={handleCheckboxChange}
                              style={{ marginRight: "10px" }}
                            />
                            {type.document}
                          </label>
                        </div>
                      );
                    })}
                  </div>
                </div>


              {/* <div className="row mt-5">
                <div className="col-md-12">
                  <label htmlFor="formGroupExampleInput">Description</label>
                  <textarea
                    className="form-control"
                    rows={6}
                    name="description"
                    value={formValue?.description}
                    onChange={(e) => { setFormValue({ ...formValue, description: e.target.value }) }}
                  ></textarea>
                </div>
              </div> */}
              <div class="col-12 ">

                <button
                  type="submit"
                  onClick={(e) => handleSubmit(e)}
                  class="btn btn-primaryb mt-5 mb-4 addBlogBn"
                  style={{
                    background: "linear-gradient(195deg, #FFB14C, #ff9000)",
                    color: "#fff",
                  }}
                >
                  Add
                </button>
              </div>
            </form>
          </section>
        </div>
      </div>



    </>
  );
};

export default AddService;
